import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Button } from '../components/Button';
import { ArrowRight } from 'lucide-react';
interface Slide5Props {
  onNext: () => void;
  onBack: () => void;
}
export function Slide5({
  onNext,
  onBack
}: Slide5Props) {
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." progress={{
    current: 2,
    total: 3
  }} onBack={onBack} data-id="element-181">
      <div className="w-full max-w-7xl mx-auto grid grid-cols-5 gap-8 items-center" data-id="element-182">
        <div className="col-span-3 space-y-3" data-id="element-183">
          <h1 className="text-2xl font-bold text-primary mb-2" data-id="element-184">
            Why dual targeting?
          </h1>
          <div className="space-y-3" data-id="element-185">
            <p className="text-base text-gray-700 leading-snug" data-id="element-186">
              Ang-2 and VEGF-A act synergistically to increase:<sup data-id="element-187">¹</sup>
            </p>
            <ul className="space-y-1 text-base text-gray-700 pl-6" data-id="element-188">
              <li className="flex items-start" data-id="element-189">
                <span className="text-accent mr-3" data-id="element-190">•</span>
                <span data-id="element-191">Vascular permeability</span>
              </li>
              <li className="flex items-start" data-id="element-192">
                <span className="text-accent mr-3" data-id="element-193">•</span>
                <span data-id="element-194">Inflammation</span>
              </li>
              <li className="flex items-start" data-id="element-195">
                <span className="text-accent mr-3" data-id="element-196">•</span>
                <span data-id="element-197">Pathological angiogenesis</span>
              </li>
            </ul>
            <p className="text-base text-gray-700 leading-snug pt-2" data-id="element-198">
              Targeting both pathways addresses mechanisms contributing to
              vascular instability.
            </p>
          </div>
          <div className="pt-2" data-id="element-199">
            <Button variant="primary" onClick={onNext} data-id="element-200">
              Why it matters
              <ArrowRight className="w-5 h-5" data-id="element-201" />
            </Button>
          </div>
        </div>
        <div className="col-span-2 flex items-center justify-center" data-id="element-202">
          <div className="relative p-1 rounded-3xl bg-gradient-to-br from-[#1B3A5C] via-[#0E8585] to-[#3DA06D]" data-id="element-203">
            <div className="bg-white rounded-3xl p-3" data-id="element-204">
              <img src="https://cdn.magicpatterns.com/uploads/6jLaiLqH5Z2ZziNHjuoZBF/Screenshot_2026-02-16_at_13.43.57.png" alt="Vascular instability showing pericyte loss, endothelial destabilization, and pathological angiogenesis" className="w-full h-auto rounded-2xl shadow-lg" data-id="element-205" />
            </div>
          </div>
        </div>
      </div>
    </SlideLayout>;
}